import { Avatar, Divider, IconButton, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { ArrowLeft, X } from "@phosphor-icons/react";
import ClientCaseload from "./ClientCaseload";
import { orange } from "@mui/material/colors";
import { useMatching } from "components/Matching/MatchingProvider";

const progressBarData = {
  hours_scheduled: { color: orange[700], legend: "Hours Scheduled" },
  proposed_hours: { color: orange[400], legend: "Proposed Hours" },
  target_hours: { color: orange[200], legend: "Target Hours" },
};

const clientCaseload = [
  {
    id: 1,
    name: "Client 1",
    total: 5,
    recurring: 3,
    proposed: 2,
    progressBarElements: [
      {
        color: progressBarData["hours_scheduled"].color,
        legend: progressBarData["hours_scheduled"].legend,
        percentage: 50,
        value: 3,
      },
      {
        color: progressBarData["proposed_hours"].color,
        legend: progressBarData["proposed_hours"].legend,
        percentage: 30,
        value: 2,
      },
      {
        color: progressBarData["target_hours"].color,
        legend: progressBarData["target_hours"].legend,
        percentage: 20,
        value: 1,
      },
    ],
  },
  {
    id: 2,
    name: "Client 2",
    total: 5,
    recurring: 3,
    proposed: 2,
  },
  {
    id: 3,
    name: "Client 3",
    total: 5,
    recurring: 3,
    proposed: 2,
  },
  {
    id: 4,
    name: "Client 4",
    total: 5,
    recurring: 3,
    proposed: 2,
  },
];

export default function BCBACaseload({ setShowCaseload }) {
  const { selectedClinician, generatedSchedules } = useMatching();
  const theme = useTheme();
  const generatedSchedule = generatedSchedules.find(
    (schedule) => schedule.clinician_id === selectedClinician
  );
  const { clinician_name } = generatedSchedule;
  const clinicianInitials = clinician_name
    .split(" ")
    .map((name) => name[0])
    .join("");

  return (
    <Stack
      width={400}
      overflow={"auto"}
      borderRight={`1px solid ${theme.palette.divider}`}
      p={7}
      gap={7}
      flexShrink={0}
    >
      <Stack direction="row" justifyContent="space-between">
        <IconButton size="small" fontSize="small" onClick={() => setShowCaseload(false)}>
          <ArrowLeft />
        </IconButton>
        <IconButton size="small" fontSize="small" onClick={() => setShowCaseload(false)}>
          <X />
        </IconButton>
      </Stack>
      <Stack direction="row" gap={3} alignItems="center">
        <Avatar size="32px">{clinicianInitials}</Avatar>
        <Typography variant="body1">{clinician_name}</Typography>
      </Stack>
      <Stack direction="row" gap={7}>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Weekly Max Target
          </Typography>
          <Typography variant="h2">36</Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Available Hours
          </Typography>
          <Typography variant="h2">7</Typography>
        </Stack>
      </Stack>
      <Stack direction="row" gap={7}>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Total
          </Typography>
          <Typography variant="h2">29</Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Recurring
          </Typography>
          <Typography variant="h2">20.5</Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            Proposed
          </Typography>
          <Typography variant="h2">8.5</Typography>
        </Stack>
      </Stack>
      <Divider />
      <Stack>
        <Typography variant="subtitle1">Clients</Typography>
        {clientCaseload.map((client) => (
          <ClientCaseload key={client.id} client={client} />
        ))}
      </Stack>
    </Stack>
  );
}
